import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../utils';
import { IBank } from '../../types/bank';
import { prepareBanks } from '../../mappers/prepareBanks';
import {
  fetchGetCachedContent,
  TGetCachedContentResponse,
} from '../../repositories/special-promos-custom/v1/get-cached-content';
import { INewbuildingsPlusBlocksPikContract } from '../../repositories/special-promos-custom/entities/ContentBlocks/NewbuildingsPlusBlocksPikContract';
import { IMortgageBanner } from '../../types/mortgageBanner';
import { prepareMortgageBanner } from '../../mappers/prepareMortgageBanner';

export async function getSpecialProjectsBlocks(
  { logger, httpApi }: IApplicationContext,
  regionId?: number,
): Promise<[IBank[], INewbuildingsPlusBlocksPikContract[], string, IMortgageBanner | null]> {
  try {
    const response: TGetCachedContentResponse = await fetchGetCachedContent({
      httpApi,
      parameters: {
        regionId,
        blocks: 'banksPik,newbuildingsPlusBlocksPik,phonesPik,mortgageBannerPik',
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSpecialProjectsBlocks',
        message: 'Не удалось получить контент для блоков специальных проектов',
      });
    }

    return [
      response.response.banksPik ? prepareBanks(response.response.banksPik) : [],
      response.response.newbuildingsPlusBlocksPik ?? [],
      response.response.phonesPik?.phone ? `+${response.response.phonesPik?.phone}` : '',
      response.response.mortgageBannerPik ? prepareMortgageBanner(response.response.mortgageBannerPik) : null,
    ];
  } catch (ex) {
    logger.warning('Получение актуальной версии блоков спецпроектов завершилось ошибкой', ex);

    return [[], [], '', null];
  }
}
